import { logout } from '../../home-page/business-logic/logout';
import { EmeraldDialogTypes } from '../enumerations/emerald-dialog-types';
import { IMessageModal } from '../interfaces/dtos/IMessageModal';

export const formatInvalidSessionError = (errorMessage?: string): IMessageModal => {
  return { message: errorMessage, type: EmeraldDialogTypes.Error, onAccept: logout };
};
